import { connect } from 'react-redux';
import ModalView from './modal_view';

const mapStateToProps = () => ({
});

const ModalContainer = connect(mapStateToProps)(ModalView);

export default ModalContainer;
